import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SrApplicantCard.less';

import { formatPhoneNumber } from 'common/formatters';

import { HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING } from 'common/householdConstants';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrProgressBarPercent, {
  SR_PROGRESS_BAR_THEME_ROUNDED_GREEN,
} from 'client/components/SrProgressBarPercent/SrProgressBarPercent';

export const SR_APPLICANT_CARD_THEME_LIGHT = 'SR_APPLICANT_CARD_THEME_LIGHT';
export const SR_APPLICANT_CARD_THEME_DARK = 'SR_APPLICANT_CARD_THEME_DARK';
const SR_APPLICANT_CARD_THEME_TO_CLASSNAME_MAPPING = {
  [SR_APPLICANT_CARD_THEME_LIGHT]: 'backgroundLight',
  [SR_APPLICANT_CARD_THEME_DARK]: 'backgroundDark',
};
const SR_APPLICANT_CARD_THEMES = Object.keys(SR_APPLICANT_CARD_THEME_TO_CLASSNAME_MAPPING);

const SrApplicantCard = ({
  name,
  phone,
  email,
  applicantTitle,
  applicationStatus,
  progressPercent,
  onClick,
  theme,
}) => {
  return (
    <SrBox
      styleName={classnames('SrApplicantCard', SR_APPLICANT_CARD_THEME_TO_CLASSNAME_MAPPING[theme])}
      onClick={onClick}
      cursor={onClick ? 'pointer' : null}
    >
      <SrFlex justify="between">
        <span styleName="name">{name}</span>
      </SrFlex>
      <SrBox marginTop="8px">
        <span styleName="text">{applicantTitle}</span>
      </SrBox>
      <SrBox marginTop="4px">
        <span styleName="text">
          {phone && formatPhoneNumber(phone)}
          {phone && email ? ' | ' : ''}
          {email}
        </span>
      </SrBox>
      <SrBox marginTop="4px">
        <span styleName="text">
          {HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[applicationStatus]}
        </span>
      </SrBox>
      <SrBox marginTop="12px" width="100%">
        <SrProgressBarPercent
          percent={progressPercent}
          theme={SR_PROGRESS_BAR_THEME_ROUNDED_GREEN}
        />
      </SrBox>
    </SrBox>
  );
};

SrApplicantCard.propTypes = {
  name: PropTypes.string.isRequired,
  phone: PropTypes.string,
  email: PropTypes.string,
  applicationStatus: PropTypes.oneOf(Object.keys(HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING))
    .isRequired,
  applicantTitle: PropTypes.string.isRequired,
  progressPercent: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(SR_APPLICANT_CARD_THEMES),
};

SrApplicantCard.defaultProps = {
  theme: SR_APPLICANT_CARD_THEME_LIGHT,
};

SrApplicantCard.displayName = 'SrApplicantCard';

export default SrApplicantCard;
